import { Panel, Tab, Tabs, Form, FormGroup, ControlLabel, Col } from 'react-bootstrap';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, Field, getFormValues, reduxForm } from 'redux-form';
import { toastr } from 'react-redux-toastr';
import { get, head, isEmpty, isEqual, orderBy, set, sortBy } from 'lodash';
import flatten from 'flat';
import { animateScroll } from 'react-scroll';
import getIncludedResource from '../../../../helpers/getIncludedResource';
import {
  Button,
  Icon,
  InfoButton,
  ButtonBar,
  Loader,
} from '../../../../common/components';
import { actions as channelActions } from '../../../channel/redux/channelActions';
import {
  actions as productActions,
} from '../../../product/redux/productActions';
import { openModal } from '../../../../common/components/Modal/ModalRedux';
import { isBroker, isBrokerOrganisation, isOwner } from '../../../auth/redux/authActions';
import { openMenu } from '../../../layout/redux/sideNavAction';
import changesToContent from '../../../../helpers/changesToContent';
import validate from './ReduxForm/validate';
import AvailableQuotes from '../AvailableQuotes';
import TripDetailsTab01 from './Components/TabContent/TripDetailsTab01';
import TravellersDetailsTab01 from './Components/TabContent/TravellersDetailsTab01';
import MedicalDeclarationTab03 from './Components/TabContent/MedicalDeclarationTab03';
import TravellersOptionsTab02 from './Components/TabContent/TravellersOptionsTab02';
import ReviewDetailsTab05 from './Components/TabContent/ReviewDetailsTab05';
import Sidebar from './Components/Sidebar/Sidebar';
import PaymentTab06 from './Components/TabContent/PaymentTab06';
import {
  goToReview,
  isGoldUpdated,
} from './Components/TabContent/redux/ReviewTabActions';
import { CoverExclusions } from '../CoverExclusions/CoverExclusions';
import PolicyUpgrades from '../PolicyUpgrades';
import PolicyOptionsMTA from '../PolicyOptionsMTA';
import PolicyUpsell from '../PolicyUpsell';
import getIncludedResource2 from '../../../../helpers/getIncludedResource2';
import { actions as screenigActions } from '../../../screening/redux/screeningActions';
import Signpost from '../Signpost/Signpost';
import confirm from 'react-confirm2';
import { FailedSanctions } from './Components/FailedSanctions/FailedSanctions';
import './styles/LeisureTravelForm.scss';
import { getValuesForSanctions } from '../../helpers';

const META = 'data.attributes.metadata';

const FORM_NAME = 'LeisureTravelForm';
const TRIP_DETAILS_TAB = 1;
const OPTIONS_TAB = 2;
const MEDICAL_TAB = 3;
const QUOTES_TAB = 4;
const REVIEW_TAB = 5;
const PAY_TAB = 6;

const FLYSURE = 'Fly-sure';

const adultsChangedForCalc = (prev, next) => {
  if (!next) {
    return false; // not initialised yet
  }
  if (next && prev?.length !== next?.length) {
    return true;
  }
  return next.reduce((carry, adult, i) => {
    const prevAdult = prev[i];
    if (
      adult.dob !== prevAdult.dob ||
      !isEqual(adult?.screening, prevAdult?.screening) ||
      adult?.address?.postcode !== prevAdult?.address?.postcode ||
      !isEqual(adult?.metadata?.options, prevAdult?.metadata?.options)
    ) {
      return true;
    }
    return carry;
  }, false);
};

export class LeisureTravelForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: TRIP_DETAILS_TAB,
      openTravellers: false,
      isMultipleSchemeSelected: false,
      isUpsellDirty: false,
      enableQuoteTab: false,
      patched: [],
      premiumForIssue: {},
      useTestSchemes: false,
      isRecalculatingScore: false,
      isConfirmingUpsell: false,
      isFlySure: false,
      ready: false,
      channelType: 'DIR',
      sanctionCheckFailed: false,
      totalSanctions: 0,
      signpostAcknowledged: false,
      quotesViewed: false,
      isReadyForIssuing: false,
      upsellScheme: undefined,
      isRescreenRequired: false,
    };
    this.handleCommissionAdjustments = this.handleCommissionAdjustments.bind(this);
    this.calculateQuotes = this.calculateQuotes.bind(this);
    this.handleTab = this.handleTab.bind(this);
    this.openSpecificTab = this.openSpecificTab.bind(this);
    this.openTravellers = this.openTravellers.bind(this);
    this.reCalculate = this.reCalculate.bind(this);
    // this.getQuotes = this.getQuotes.bind(this);
    this.handlePaymentTab = this.handlePaymentTab.bind(this);
    this.enableQuoteTab = this.enableQuoteTab.bind(this);
    this.clearScreeningError = this.clearScreeningError.bind(this);
    this.singleCalculation = this.singleCalculation.bind(this);
    this.goTab01 = this.goTab01.bind(this);
    this.openReviewTab = this.openReviewTab.bind(this);
    this.handleSchemeSelect = this.handleSchemeSelect.bind(this);
    this.retrieveUpgrade = this.retrieveUpgrade.bind(this);
    this.handleUpsellModal = this.handleUpsellModal.bind(this);
    this.confirmUpsell = this.confirmUpsell.bind(this);
    this.handleBackReviewTab = this.handleBackReviewTab.bind(this);
    this.handleSaveApplication = this.handleSaveApplication.bind(this);
    // this.saveQuotesPatch = this.saveQuotesPatch.bind(this);
    this.revertUpsell = this.revertUpsell.bind(this);
    this.submitSaveApplication = this.submitSaveApplication.bind(this);
    this.handleToggleTest = this.handleToggleTest.bind(this);
  }

  componentDidMount() {
    const { dispatch, change, formValues, mta, resource, source } = this.props;
    // redux-form validation according to the tab
    dispatch(change('data.current_tab', TRIP_DETAILS_TAB));
    // boltOns initial value
    dispatch(isGoldUpdated(false));
    dispatch(openMenu(false));
    const metaPolicyUpgrade = 'data.attributes.metadata.upgrade';
    if (isEmpty(get(formValues, `${metaPolicyUpgrade}`, []))) {
      dispatch(change(`${metaPolicyUpgrade}`, 'Gold'));
    }

    if (mta) {
      const premiumsResources = getIncludedResource2(
        resource.data,
        resource.included,
        'premiums',
        true,
      );
      const premium = orderBy(
        premiumsResources,
        function(premium) {
          return premium.attributes.version;
        },
        'desc',
      )[0];

      if (premium) {
        dispatch(
          change('data.relationships.schemes.data', [
            {
              type: 'product/schemes',
              id: premium.relationships.scheme.data.id,
            },
          ]),
        );
      }
    }

    this.handleFlySure(null, source);
    this.setState({
      ready: true,
    });
  }

  updateCurrentTab = (tabNumber) => {
    const { dispatch, change } = this.props;
    dispatch(change('data.current_tab', tabNumber));
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      formValues,
      product,
      dispatch,
      change,
      resource,
      source,
      mta,
      upgradeModal,
      mtaUpgradeModal,
    } = this.props;
    const schemeType = get(formValues, 'data.attributes.metadata.scheme_type');
    const prevSchemeType = get(
      prevProps.formValues,
      'data.attributes.metadata.scheme_type',
    );

    const travelDispute = get(
      formValues,
      'data.attributes.metadata.options.travel_dispute',
    );
    const prevTravelDispute = get(
      prevProps.formValues,
      'data.attributes.metadata.options.travel_dispute',
    );

    const endSupplierFailure = get(
      formValues,
      'data.attributes.metadata.options.end_supplier_failure',
    );
    const prevEndSupplierFailure = get(
      prevProps.formValues,
      'data.attributes.metadata.options.end_supplier_failure',
    );

    const smartLuggage = get(
      formValues,
      'data.attributes.metadata.options.smart_luggage',
    );
    const prevSmartLuggage = get(
      prevProps.formValues,
      'data.attributes.metadata.options.smart_luggage',
    );

    const excBaggage = get(
      formValues,
      'data.attributes.metadata.options.exclude_baggage',
      false,
    );
    const prevExcBaggage = get(
      prevProps.formValues,
      'data.attributes.metadata.options.exclude_baggage',
      false,
    );
    const excWaiver = get(
      formValues,
      'data.attributes.metadata.options.excess_waiver',
      false,
    );
    const prevExcWaiver = get(
      prevProps.formValues,
      'data.attributes.metadata.options.excess_waiver',
      false,
    );

    const excCancellation = get(
      formValues,
      'data.attributes.metadata.options.exclude_cancellation',
      false,
    );
    const prevExcCancellation = get(
      prevProps.formValues,
      'data.attributes.metadata.options.exclude_cancellation',
      false,
    );

    const campaignId = get(formValues, 'data.attributes.metadata.campaign');
    const prevCampaignId = get(prevProps.formValues, 'data.attributes.metadata.campaign');

    const campaignCode = get(formValues, 'data.attributes.metadata.campaign_code');

    const prevCampaignCode = get(
      prevProps.formValues,
      'data.attributes.metadata.campaign_code',
    );

    const postageOptionEmail = get(
      formValues,
      'data.attributes.metadata.communications.email',
    );

    const prevPostageOptionEmail = get(
      prevProps.formValues,
      'data.attributes.metadata.communications.email',
    );

    const postageOptionSms = get(
      formValues,
      'data.attributes.metadata.communications.email',
    );

    const prevPostageOptionSms = get(
      prevProps.formValues,
      'data.attributes.metadata.communications.email',
    );

    const cruiseCover = get(formValues, 'data.attributes.metadata.options.cruise_cover');
    const prevCruiseCover = get(
      prevProps.formValues,
      'data.attributes.metadata.options.cruise_cover',
    );

    const medicalProps = get(
      formValues,
      'data.attributes.metadata.medical_declaration_questions',
      0,
    );
    const prevMedicalProps = get(
      prevProps.formValues,
      'data.attributes.metadata.medical_declaration_questions',
      0,
    );

    const prevBrokerId = get(prevProps.product, 'source.relationships.broker.data.id');
    const brokerId = get(this.props.product, 'source.relationships.broker.data.id');

    if (get(prevProps.source, 'id') !== get(source, 'id')) {
      this.handleSourceChange(source);
    }

    if (cruiseCover !== prevCruiseCover) {
      //store cruise so we can retrieve if it get's deleted when policy is issue( deletes if not offered)
      dispatch(change('data.attributes.metadata.storage.cruise_cover', prevCruiseCover));
    }

    // if qutoe only has campaign code (because originated on b2c) then set the campaign id
    // so campaign select will display properly
    if (campaignCode && !campaignId) {
      const includedCampaignId = get(
        getIncludedResource(resource.data, resource.included, 'campaign'),
        'data.id',
      );
      if (includedCampaignId) {
        dispatch(change('data.attributes.metadata.campaign', includedCampaignId));
      }
    }

    if (campaignCode && campaignId !== prevCampaignId) {
      dispatch(change('data.attributes.metadata.campaign_code', ''));
    }

    // Get the selected scheme
    const selectedSchemes = get(formValues, 'data.relationships.schemes.data', []);
    const selectedSchemesPrev = get(
      prevProps.formValues,
      'data.relationships.schemes.data',
      [],
    );
    const selectedScheme =
      selectedSchemes && selectedSchemes.length === 1 ? selectedSchemes[0] : undefined;
    const selectedSchemePrev =
      selectedSchemesPrev && selectedSchemesPrev.length === 1
        ? selectedSchemesPrev[0]
        : undefined;

    const totalPremium =
      selectedScheme && product.quotes ? product.quotes[selectedScheme.id] : undefined;

    // Remove max_trip_duration for trip type in case of change
    if (
      schemeType &&
      schemeType !== prevSchemeType &&
      this.state.activeTab === TRIP_DETAILS_TAB
    ) {
      if (schemeType === 'single') {
        dispatch(change('data.attributes.metadata.max_trip_duration', null));
        dispatch(change('data.attributes.metadata.region', ''));
        this.setState({
          isUpsellDirty: false,
        });
      }
      // Remove Destination if user clicks on Annual Multi-trip
      if (schemeType === 'annual') {
        dispatch(change('data.attributes.metadata.destinations', []));
      }
      // Cleaforr Quotes in case of Trip Type change
      if (!!selectedScheme && !!totalPremium) {
        dispatch(change('data.relationships.schemes.data', []));
      }
    }

    //if premium indication returned an error remove from selected schemes
    const premiumIndicationError = get(product, 'premiumIndicationError');
    if (premiumIndicationError && get(premiumIndicationError, 'schemeId')) {
      const index = get(formValues, 'data.relationships.schemes.data', []).findIndex(
        (scheme) => {
          return scheme.id === premiumIndicationError.schemeId;
        },
      );
      if (index >= 0) {
        const updateSelection = this.props.array;
        updateSelection.remove('data.relationships.schemes.data', index);
      }
    }

    //if 0 premiums returned remove from selected schemes
    if (product.quotes) {
      selectedSchemes.forEach((scheme, key) => {
        const selectedSchemePremium = product.quotes[scheme.id];
        if (!this.props.mta && get(selectedSchemePremium, 'meta.premium.gross') === 0) {
          const updateSelection = this.props.array;
          updateSelection.remove('data.relationships.schemes.data', key);
        }
      });
    }

    // If medical answer changes, clear the quotes
    if (
      !isEqual(medicalProps, prevMedicalProps) &&
      (medicalProps !== 0 && prevMedicalProps !== 0)
    ) {
      dispatch(change('data.relationships.schemes.data', []));
    }

    if (prevBrokerId !== brokerId) {
      dispatch(change('data.relationships.broker.data.id', brokerId));
    }

    if (prevState.activeTab !== this.state.activeTab) {
      dispatch(change('data.current_tab', this.state.activeTab));
      scrollToTop();
    }

    if (mta) {
      if (!get(formValues, 'data.mta')) {
        dispatch(change('data.mta', true));
      }

      const selectedSchemes = get(formValues, 'data.relationships.schemes.data', []);

      const prevSelectedSchemes = get(
        prevProps.formValues,
        'data.relationships.schemes.data',
        [],
      );
      const selectedSchemeId = get(selectedSchemes[0], 'id');
      const prevSelectedSchemeId = get(prevSelectedSchemes[0], 'id');
      const currentQuote = product.quotes?.[selectedSchemeId];
      const prevProductQuote = prevProps.product.quotes?.[prevSelectedSchemeId];

      const changesCurrent = get(currentQuote, 'meta.mta.changes');
      const prevChanges = get(prevProductQuote, 'meta.mta.changes');

      if (!isEqual(changesCurrent, prevChanges)) {
        dispatch(
          change(
            'data.attributes.metadata.storage.endorsements[0].title',
            'Mid-term Adjustment',
          ),
        );
        dispatch(
          change(
            'data.attributes.metadata.storage.endorsements[0].content',
            changesToContent(get(currentQuote, 'meta.mta.changes', [])),
          ),
        );
      }
    }

    if (
      (postageOptionEmail !== prevPostageOptionEmail ||
        postageOptionEmail !==
          get(formValues, 'data.attributes.metadata.send_email', false)) &&
      get(formValues, 'data.attributes.metadata.adults[0].email', false)
    ) {
      dispatch(change('data.attributes.metadata.send_email', postageOptionEmail));
    }

    if (
      (postageOptionSms !== prevPostageOptionSms ||
        postageOptionSms !==
          get(formValues, 'data.attributes.metadata.send_sms', false)) &&
      get(formValues, 'data.attributes.metadata.adults[0].phone2', false)
    ) {
      dispatch(change('data.attributes.metadata.send_sms', postageOptionSms));
    }
    const modalIsVisible =
      (upgradeModal && upgradeModal.visible) ||
      (mtaUpgradeModal && mtaUpgradeModal.visible);

    const adults = get(formValues, 'data.attributes.metadata.adults');
    const children = get(formValues, 'data.attributes.metadata.children');
    const adultsPrev = get(prevProps.formValues, 'data.attributes.metadata.adults');
    const childrenPrev = get(prevProps.formValues, 'data.attributes.metadata.children');
    const newSchemeSelected = selectedScheme && selectedScheme !== selectedSchemePrev;

    const isRecalculatingScore = this.state.isRecalculatingScore;
    const isConfirmingUpsell = this.state.isConfirmingUpsell;
    /**
     *   list of values that if changed affect the premium
     *   notable exceptions
     *   - destinations we don't what to be recalculating panel multiple times when destinations are changed so destination change logic it handled separately
     *   - adults/children on rescreen - medical recalcs will update each traveller separately, we don't want each screening update to trigger a recalc so we prevent traveller updates from triggering a recalc if the score is currently being calculated
     *   - scheme change as part of an upsell
     */

    if (
      !isConfirmingUpsell &&
      (newSchemeSelected ||
        (schemeType && schemeType !== prevSchemeType) ||
        campaignId !== prevCampaignId ||
        (campaignCode !== undefined && campaignCode !== prevCampaignCode) ||
        (adultsChangedForCalc(adults, adultsPrev) && !isRecalculatingScore) ||
        (children && !isEqual(children, childrenPrev) && !isRecalculatingScore) ||
        (travelDispute !== undefined && travelDispute !== prevTravelDispute) ||
        (endSupplierFailure !== undefined &&
          endSupplierFailure !== prevEndSupplierFailure) ||
        (smartLuggage !== undefined && smartLuggage !== prevSmartLuggage) ||
        (excWaiver !== undefined && excWaiver !== prevExcWaiver) ||
        (excBaggage !== undefined && excBaggage !== prevExcBaggage) ||
        (excCancellation !== undefined && excCancellation !== prevExcCancellation))
    ) {
      // Single Calc changes - if there is a selected scheme  then do a single scheme calc to get the premium indication
      if (selectedScheme && totalPremium) {
        this.singleCalculation(selectedScheme);
        const calcPanel = !newSchemeSelected && (!modalIsVisible || mta);
        if (this.state.activeTab === QUOTES_TAB && calcPanel) {
          this.reCalculate();
        }
      } else {
        // Full recalc -for the panel
        if (this.state.activeTab === QUOTES_TAB && !isConfirmingUpsell) {
          this.reCalculate();
        }
      }
    }
  }

  goTab01() {
    this.openSpecificTab(TRIP_DETAILS_TAB);
  }

  // Enable Quote Tab only if you pass through Medical
  enableQuoteTab() {
    this.setState(() => ({
      enableQuoteTab: true,
    }));
  }
  clearScreeningError() {
    this.setState({
      isRescreenRequired: false,
    });
  }

  confirmUpsell() {
    /*
     * The confirm Upsell will update the display_only fields to real fields
     */
    const { dispatch, change, formValues, product, array } = this.props;
    this.setState({
      isConfirmingUpsell: true,
    });
    const getMaxTripDisplayOnly = get(
      formValues,
      'data.attributes.metadata.max_trip_duration_display_only',
    );
    const getRegionDisplayOnly = get(
      formValues,
      'data.attributes.metadata.storage.region_display_only',
    );

    const getCountries = get(formValues, 'data.attributes.metadata.destinations');
    const schemes = get(formValues, 'data.relationships.schemes.data');
    if (schemes) {
      const newSelectedSchemeList = schemes.filter((scheme) => {
        const selectedScheme = get(product.quotes, scheme.id);
        return selectedScheme.meta.scheme.scheme_type === 'annual';
      });
      dispatch(change('data.relationships.schemes.data', newSelectedSchemeList));
    }

    Promise.resolve(
      this.recalulateTravellerMedical(null, getRegionDisplayOnly, false),
    ).finally(() => {
      dispatch(change('data.attributes.metadata.generate_documents', true));
      array.push('data.relationships.schemes.data', this.state.upsellScheme);
      dispatch(change(`${META}.region`, getRegionDisplayOnly));
      dispatch(change(`${META}.max_trip_duration`, getMaxTripDisplayOnly));
      dispatch(change(`${META}.destinationsBackup`, getCountries));
      dispatch(change(`${META}.destinations`, []));
      dispatch(change(`${META}.scheme_type`, 'annual'));
      dispatch(change(`${META}.end_date`, ''));

      this.singleCalculation(this.state.upsellScheme);
      this.reCalculate();
      this.setState({
        isUpsellDirty: true,
        isConfirmingUpsell: false,
        upsellScheme: undefined,
      });
    });
  }

  revertUpsell() {
    const { dispatch, change, formValues } = this.props;
    const getDestinationsBackup = get(
      formValues,
      'data.attributes.metadata.destinationsBackup',
    );
    const dispatchRevert = () => {
      dispatch(change(`${META}.scheme_type`, 'single'));
      dispatch(change(`${META}.max_trip_duration`, 0));
      dispatch(change('data.relationships.schemes.data', []));
      if (getDestinationsBackup) {
        dispatch(change(`${META}.destinations`, getDestinationsBackup));
      }
      this.recalulateTravellerMedical(getDestinationsBackup, null, false);
    };

    // Change the Tab and perform the revert
    this.setState(
      () => ({
        activeTab: TRIP_DETAILS_TAB,
        isUpsellDirty: false,
      }),
      dispatchRevert(),
    );
  }

  handleFlySure(channel, source) {
    const { dispatch, change } = this.props;
    const isSourceFlySure = get(source, 'attributes.name', '').includes(FLYSURE);
    const isChannelFlySure = get(channel, 'attributes.name', '').includes(FLYSURE);

    const isFlySure = isSourceFlySure || isChannelFlySure;
    this.setState({
      isFlySure: isFlySure,
    });
    if (isFlySure) {
      dispatch(change('data.attributes.metadata.scheme_type', 'annual'));
    }
  }

  handleChannelChange = (newChannel) => {
    const { dispatch, change } = this.props;

    dispatch(change('data.attributes.metadata.sales_channel', null));
    this.handleFlySure(newChannel.data, null);
  };

  handleBrokerChange = (source) => {
    const { dispatch, change } = this.props;
    dispatch(change('data.relationships.channel.data.id', ''));
    if (source.attributes.broker_type === 'broker') {
      dispatch(change('data.attributes.metadata.sales_channel', 'jtc-b2b'));
      this.setState({
        channelType: 'B2B',
      });
    } else {
      dispatch(change('data.attributes.metadata.sales_channel', null));
      this.setState({
        channelType: 'DIR',
      });
    }
    this.handleFlySure(null, source);
  };

  handleSourceChange(value) {
    const { dispatch, change } = this.props;
    const promises = [];
    this.setState({
      ready: false,
    });
    if (!value) {
      promises.push(dispatch(change('data.relationships.broker.data.id', '')));
      promises.push(dispatch(change('data.relationships.channel.data.id', '')));
    } else {
      promises.push(dispatch(change('data.relationships.source.data.id', value.id)));
      if (!isBroker()) {
        if (value.attributes.is_broker) {
          const brokerIdFromSource = value.relationships.broker.data.id;
          promises.push(
            dispatch(change('data.relationships.broker.data.id', brokerIdFromSource)),
          );
          promises.push(this.handleBrokerChange(value));
        }

        if (value.attributes.is_channel) {
          const channelIdFromSource = value.relationships.channel.data.id;

          promises.push(this.updateChannel(channelIdFromSource));
          promises.push(
            dispatch(change('data.relationships.channel.data.id', channelIdFromSource)),
          );
          promises.push(dispatch(change('data.relationships.broker.data.id', '')));
          this.setState({
            channelType: value.attributes.channel_type,
          });
        }
      }
    }
    Promise.all(promises).then(() => {
      this.setState({
        ready: true,
      });
    });
  }

  updateChannel(channelIdFromSource) {
    const { onGetChannel } = this.props;
    return Promise.resolve(onGetChannel(channelIdFromSource)).then((resp) => {
      this.handleChannelChange(resp);
    });
  }

  handleCommissionAdjustments() {
    const { formValues, product } = this.props;
    // Get the selected scheme
    const schemes = get(formValues, 'data.relationships.schemes.data', []);

    if (schemes.length === 1) {
      const scheme = head(schemes);
      const selection = get(product.quotes, scheme.id);
      this.singleCalculation(selection);
    }
  }

  handleToggleTest(useTest) {
    Promise.resolve(
      this.setState({
        useTestSchemes: useTest,
      }),
    ).then(() => {
      this.reCalculate();
    });
  }

  recalculateMedical = (screeningId, destinations, region, path) => {
    const { onRecalculateScore } = this.props;
    return Promise.resolve(
      onRecalculateScore(
        null,
        screeningId,
        destinations ? null : region,
        destinations,
        'verisk',
      ),
    )
      .then((result) => {
        return this.updateTravellerScreening(result.screening_id, result.screening, path);
      })
      .catch(() => {
        this.setState({
          isRescreenRequired: true,
        });
      });
  };

  recalulateTravellerMedical = (destinations, region, doRecalc) => {
    const { product, formValues } = this.props;
    const adults = formValues.data.attributes.metadata.adults || [];
    const children = formValues.data.attributes.metadata.children || [];

    const adultPaths = adults.reduce((carry, traveller, index) => {
      if (traveller.screening_id) {
        carry.push(`data.attributes.metadata.adults.${index}`);
      }
      return carry;
    }, []);
    const childPaths = children.reduce((carry, traveller, index) => {
      if (traveller.screening_id) {
        carry.push(`data.attributes.metadata.children.${index}`);
      }
      return carry;
    }, []);
    const paths = adultPaths.concat(childPaths);
    this.setState({
      isRecalculatingScore: true,
    });
    const promises = paths.map((path) => {
      const traveller = get(formValues, path);
      return this.recalculateMedical(traveller.screening_id, destinations, region, path);
    });

    return Promise.all(promises)
      .then(() => {
        if (product.quotes && this.state.quotesViewed && doRecalc) {
          const schemes = get(formValues, 'data.relationships.schemes.data', []);

          if (schemes.length === 1) {
            const scheme = head(schemes);
            const selection = get(product.quotes, scheme.id);
            this.singleCalculation(selection);
          }
        }
      })
      .finally(() => {
        this.setState({
          isRecalculatingScore: false,
        });
      });
  };

  handleRegionDestinationChange = (values, name) => {
    if (!values || !values?.length) {
      return;
    }
    const destinationHasChanged = name === 'data.attributes.metadata.destinations';
    const regionHasChanged = name === 'data.attributes.metadata.region';
    const region = regionHasChanged ? values : null;
    const destinations = destinationHasChanged ? values : null;
    if (destinations || region) {
      this.recalulateTravellerMedical(destinations, region, true);
    }
  };

  updateTravellerScreening = (screeningId, screening, path) => {
    const { dispatch, change } = this.props;
    dispatch(change(`${path}.screening_id`, screeningId));
    dispatch(change(`${path}.screening`, screening));
    dispatch(
      change(
        'data.attributes.metadata.has_medical_annual_exclusion',
        screening.meta.hasAnnualExclusion,
      ),
    );
  };

  handleSchemeSelect(schemeId, replace) {
    const { product, dispatch, change, mta, formValues } = this.props;

    const selectedSchemes = get(formValues, 'data.relationships.schemes.data', []);

    const updateSelection = this.props.array;

    if (get(formValues, 'data.attributes.metadata.overrides.commission_owner')) {
      dispatch(change('data.attributes.metadata.overrides.commission_owner', null));
    }

    const schemeIndex = selectedSchemes
      ? selectedSchemes.findIndex((scheme) => {
          return scheme.id === schemeId;
        })
      : -1;
    if (schemeIndex >= 0) {
      updateSelection.remove('data.relationships.schemes.data', schemeIndex);
    } else {
      const selectedQuote = product.quotes[schemeId];

      const selectedScheme = get(selectedQuote, 'meta.scheme');

      const schemeType = get(formValues, `${META}.scheme_type`);
      if (schemeType === 'single') {
        const isUpSell = get(selectedScheme, 'quote_type', false) === 'upsell';
        if (isUpSell) {
          this.setState({
            upsellScheme: selectedScheme,
          });
          return this.handleUpsellModal();
        }
      }
      if (
        !mta &&
        get(selectedScheme, 'cover_level') !== 'Gold' &&
        selectedSchemes.length === 0
      ) {
        dispatch(isGoldUpdated(false));
      }
      if (replace && selectedSchemes.length === 1) {
        updateSelection.removeAll('data.relationships.schemes.data'); // remove the previous scheme
      }
      dispatch(change('data.attributes.metadata.generate_documents', true));
      updateSelection.push('data.relationships.schemes.data', selectedScheme);
    }
  }

  retrieveUpgrade() {
    const { formValues, product, change, dispatch } = this.props;
    const metaPolicyUpgrade = 'data.attributes.metadata.upgrade';
    if (isEmpty(get(formValues, `${metaPolicyUpgrade}`, []))) {
      dispatch(change(`${metaPolicyUpgrade}`, 'Gold'));
    }
    const premium = get(formValues, 'data.relationships.schemes.data', []);
    if (premium && premium.length === 1) {
      const schemeSelected = get(product.quotes, premium[0].id);
      this.singleCalculation(schemeSelected);
    }
  }

  // Invoked when the Tab is clicked
  handleTab(key) {
    const { screening, dispatch, handleSubmit, error, change, formValues } = this.props;
    const { isRescreenRequired } = this.state;
    if (screening.index > 0) {
      return toastr.error(
        'Screening session active',
        'Please finish your current screening session before continuing',
      );
    }

    if (key === QUOTES_TAB && isRescreenRequired) {
      return;
    }

    // Don't change the tab if the flag is false
    if (key === QUOTES_TAB && this.state.enableQuoteTab === false) {
      if (!this.props.edit && !this.props.mta) {
        return;
      }
    }

    // If there is a error in validation, do not proceed
    const formErrors = error && error instanceof Object ? flatten(error) : false;
    if (formErrors) {
      dispatch(handleSubmit(() => {}));
    }

    // Get the Premium selected to display in the SideBar
    const premium = get(formValues, 'data.relationships.schemes.data', []);
    let getPremium = premium && premium.length === 1 ? premium : 0; // 0 = no scheme selected
    let selection = {};
    if (getPremium !== 0) {
      selection = get(this.props.product.quotes, premium[0].id);
    }

    // If there you are in Quote Tab and no selection is made, do not proceed
    let isSelectedQuote = true;
    if (
      this.state.activeTab === QUOTES_TAB &&
      isEmpty(selection) &&
      (key === REVIEW_TAB || key === PAY_TAB)
    ) {
      this.setState({
        isMultipleSchemeSelected: true,
      });
      isSelectedQuote = false;
    } else {
      this.setState({
        isMultipleSchemeSelected: false,
      });
    }

    // hacking this is validate the signposting - this whole section need to be refactors to use proper validation
    const signposted = get(formValues, 'data.attributes.metadata.signposted', false);
    const isSignpostAcknowledged = signposted
      ? get(formValues, 'data.attributes.metadata.signpost_acknowledged', false)
      : true;

    // If no errors, change the tab and invokes the handleSubmit
    if ((!formErrors && isSelectedQuote) || key < get(formValues, 'data.current_tab')) {
      if (key === PAY_TAB && isSignpostAcknowledged) {
        dispatch(handleSubmit(this.handlePaymentTab), () => {
          this.setState({
            activeTab: key,
          });
        });
      } else {
        if (key === REVIEW_TAB) {
          return this.openReviewTab(REVIEW_TAB);
        }
        this.setState(
          {
            activeTab: key,
          },
          () => {
            dispatch(goToReview(false)); // reset the flag to avoid redirection in cWRP
            if (this.state.activeTab === QUOTES_TAB) {
              dispatch(change('data.current_tab', QUOTES_TAB));
              this.calculateQuotes(formValues);

              // get premium indication for selected scheme
              const selectedSchemes = get(
                formValues,
                'data.relationships.schemes.data',
                [],
              );
              if (selectedSchemes.length === 1) {
                const schemeSelected = head(selectedSchemes);
                this.singleCalculation(schemeSelected);
              }
            }
          },
        );
      }
    }
  }

  handleBackReviewTab() {
    const { dispatch } = this.props;
    dispatch(goToReview(false)); // reset the flag to avoid redirection in cWRP
    this.openSpecificTab(QUOTES_TAB);
    this.reCalculate(); // recalculate again to handle changes for all schemes e.g.: Travel Dispute
  }

  openTravellers(value) {
    const { dispatch, change } = this.props;
    dispatch(change('data.attributes.metadata.traveller_group', value));
  }

  showUpgradeModal = (scheme, selectedPremium) => {
    if (!scheme || scheme.length !== 1) {
      return false;
    }

    const hasUpgrade =
      get(selectedPremium, 'meta.information.upgrade.amount.difference') > 0;
    if (hasUpgrade) {
      return true;
    }

    const availableOptions = get(selectedPremium, 'meta.information.available_options');
    return Object.values(availableOptions).reduce((carry, option) => {
      if (option.is_bolt_on) {
        return true;
      }
      return carry;
    }, false);
  };
  showMTAUpgradeModal = (scheme, selectedPremium) => {
    if (!scheme || scheme.length !== 1) {
      return false;
    }
    const availableOptions = get(selectedPremium, 'meta.information.available_options');
    if (!availableOptions) {
      return false;
    }
    return Object.values(availableOptions).reduce((carry, option) => {
      if (option.is_bolt_on) {
        return true;
      }
      return carry;
    }, false);
  };

  openReviewTab(key) {
    const { formValues, product, dispatch, mta } = this.props;
    const { activeTab } = this.state;
    const premium = get(formValues, 'data.relationships.schemes.data', []);

    let getPremium = premium && premium.length === 1 ? premium : 0; // 0 = no scheme selected
    let selection = {};
    if (getPremium !== 0) {
      selection = get(product.quotes, premium[0].id);
    }
    //hacky and horrid - needs to be refactored in proper validation
    const signposted = get(formValues, 'data.attributes.metadata.signposted', false);
    const isSignpostAcknowledged = signposted
      ? get(formValues, 'data.attributes.metadata.signpost_acknowledged', false)
      : true;
    const preventReview = isEmpty(selection) || !isSignpostAcknowledged;
    if (key < activeTab) {
      this.setState(() => ({ activeTab: REVIEW_TAB }));
    } else {
      if (
        activeTab === QUOTES_TAB &&
        preventReview &&
        (key === REVIEW_TAB || key === PAY_TAB)
      ) {
        this.setState(() => ({
          isMultipleSchemeSelected: true,
        }));
      } else {
        const isGold = get(selection, 'meta.scheme.cover_level') === 'Gold';

        if (mta && !isGold && this.showMTAUpgradeModal(premium, selection)) {
          return dispatch(openModal('policyOptionsMTA'));
        }
        if (!mta && !isGold && this.showUpgradeModal(premium, selection)) {
          return dispatch(openModal('upgradeToGold'));
        }
        this.setState(() => ({ activeTab: REVIEW_TAB }));
      }
    }
  }

  handleUpsellModal() {
    const { dispatch } = this.props;
    if (!this.state.isUpsellDirty) {
      dispatch(openModal('PolicyUpsell'));
    }
  }

  openSpecificTab(key) {
    const { formValues, product } = this.props;
    // Validate if there is one scheme selected before open tab
    const premium = get(formValues, 'data.relationships.schemes.data', []);
    let getPremium = premium && premium.length === 1 ? premium : 0; // 0 = no scheme selected
    let selection = {};
    if (getPremium !== 0) {
      selection = get(product.quotes, premium[0].id);
    }
    if (
      this.state.activeTab === QUOTES_TAB &&
      isEmpty(selection) &&
      (key === REVIEW_TAB || key === PAY_TAB)
    ) {
      this.setState(() => ({
        isMultipleSchemeSelected: true,
      }));
    } else {
      this.setState(() => ({
        isMultipleSchemeSelected: false,
        activeTab: key,
      }));
    }
  }

  goToNextPage = () => {
    this.handleTab(this.state.activeTab + 1);
  };

  goToPreviousPage = () => {
    this.openSpecificTab(this.state.activeTab - 1);
  };

  goToReview = () => {
    this.openSpecificTab(REVIEW_TAB);
  };

  goToQuotes = () => {
    const { dispatch, change, handleSubmit, formValues } = this.props;
    const { isRescreenRequired } = this.state;
    const questions = get(
      formValues,
      'data.attributes.metadata.medical_declaration_questions',
      [],
    );
    const questionList = Object.values(questions);
    const isScreeningRequired = !!questionList.find(
      (question) => question.question_type === 'boolean' && question.answer,
    );
    const adults = formValues?.data.attributes.metadata?.adults ?? [];
    const children = formValues?.data.attributes.metadata?.children ?? [];
    const travellers = adults.concat(children);
    const hasConditions = travellers.reduce((carry, traveller) => {
      return carry || !isEmpty(get(traveller, 'screening.meta.conditions'));
    }, false);

    const showNoConditionsScreenedWarning = isScreeningRequired && !hasConditions;
    const clearScreenedConditions = !isScreeningRequired && hasConditions;

    if (showNoConditionsScreenedWarning) {
      confirm('Warning', {
        description: (
          <div>
            You have not screened for any conditions. Are you sure you wish to continue?
          </div>
        ),
        done: () => {
          dispatch(handleSubmit(this.calculateQuotes));
        },
        close: () => {
          return true;
        },
      });
      return;
    }
    if (isRescreenRequired) {
      return;
    }
    if (clearScreenedConditions) {
      // In this case because we are changing the form we can rely on the componentdidupdate to detect the change in props and recalculate the pnnel
      Object.keys(adults).forEach((adultKey) => {
        dispatch(change(`data.attributes.metadata.adults.${adultKey}.screening_id`, ''));
        dispatch(change(`data.attributes.metadata.adults.${adultKey}.screening`, ''));
      });
      Object.keys(children).forEach((childKey) => {
        dispatch(change(`data.attributes.metadata.adults.${childKey}.screening_id`, ''));
        dispatch(change(`data.attributes.metadata.adults.${childKey}.screening`, ''));
      });
      this.openSpecificTab(QUOTES_TAB);
      return;
    }

    dispatch(handleSubmit(this.calculateQuotes));
  };

  getQuotesAndSignposting = (values) => {
    const { dispatch, change, onGetQuotes } = this.props;
    const { useTestSchemes } = this.state;
    const sourceId = get(values, 'data.relationships.source.data.id');
    const isRenewal = get(values, 'data.attributes.quote_type') === 'renewal';
    const channelId = isRenewal
      ? get(values, 'data.relationships.channel.data.id')
      : null;
    const filters = useTestSchemes ? ['filter[status]=test,active'] : [];
    return Promise.resolve(onGetQuotes(sourceId, values, channelId, filters)).then(
      (resp) => {
        dispatch(change('data.attributes.metadata.signposted', resp));
        dispatch(change('data.attributes.metadata.signpost_acknowledged', ''));
        return resp;
      },
    );
  };

  getAdjustmentAndSignposting = (values) => {
    const { dispatch, change, policyId, onCalculateAdjustment } = this.props;
    Promise.resolve(onCalculateAdjustment(policyId, values)).then((resp) => {
      dispatch(change('data.attributes.metadata.signposted', resp));
      dispatch(change('data.attributes.metadata.signpost_acknowledged', ''));
    });
  };

  calculateQuotes(values) {
    const { change, dispatch, mta, formValues } = this.props;
    this.setState({
      quotesViewed: true,
    });
    if (mta) {
      // calculate adjustment
      if (!this.state.savedQuotesFlag) {
        Promise.resolve(this.submitSaveApplication())
          .then((resp) => {
            this.getAdjustmentAndSignposting(resp);
          })
          .then(() => {
            this.setState({
              savedQuotesFlag: true,
            });
          });
      } else {
        this.getAdjustmentAndSignposting(values);
      }
    } else {
      if (!this.state.savedQuotesFlag) {
        const getCountries = get(formValues, 'data.attributes.metadata.destinations');
        dispatch(change('data.attributes.metadata.destinationsBackup', getCountries));
        Promise.resolve(this.submitSaveApplication())
          .then((resp) => {
            this.getQuotesAndSignposting(resp);
          })
          .then(() => {
            this.setState({
              savedQuotesFlag: true,
            });
          });
      } else {
        this.getQuotesAndSignposting(values);
      }
    }

    const selectedSchemes = get(values, 'data.relationships.schemes.data', []);
    if (selectedSchemes.length === 1) {
      const schemeSelected = head(selectedSchemes);
      this.singleCalculation(schemeSelected);
    }
    this.setState({
      activeTab: QUOTES_TAB,
    });
  }

  reCalculate() {
    const { dispatch, handleSubmit, mta } = this.props;

    if (mta) {
      dispatch(handleSubmit(this.getAdjustmentAndSignposting));
    } else {
      dispatch(handleSubmit(this.getQuotesAndSignposting));
    }
  }

  singleCalculation(scheme) {
    const { mta, onGetPremiumIndication } = this.props;
    if (mta) {
      return;
    }
    scheme = get(scheme, 'meta.scheme.id', false) ? get(scheme, 'meta.scheme') : scheme;
    if (scheme) {
      onGetPremiumIndication(scheme, 'LeisureTravelForm');
    }
  }

  submitSaveApplication() {
    const { dispatch, handleSubmit } = this.props;
    return Promise.resolve(dispatch(handleSubmit(this.handleSaveApplication))).then(
      (resp) => {
        return resp;
      },
    );
  }

  handleSaveApplication(application) {
    const {
      currentProduct,
      dispatch,
      change,
      mta,
      onIsSaving,
      onSubmitSucceeded,
      onSaveApplication,
    } = this.props;
    onSubmitSucceeded(false);
    onIsSaving(true);
    return onSaveApplication(
      application,
      currentProduct,
      (values) => {
        dispatch(change('data.id', values.data.id));
        this.setState(() => ({
          application: values,
        }));

        onSubmitSucceeded(true);
        onIsSaving(false);
      },
      mta,
    );
  }

  handleUpdateApplicationForPaymentTab = (application) => {
    const {
      dispatch,
      change,
      currentProduct,
      mta,
      onSaveApplication,
      onUpdateApplication,
      onSubmitSucceeded,
      onIsSaving,
    } = this.props;

    const applicationId = application.data.id;

    if (mta) {
      // This needs to be a POST for now as a calculate on a PUT defaults to current active scheme
      return Promise.resolve(
        onSaveApplication(application, currentProduct, null, mta, true),
      )
        .then((values) => {
          const premiumIds = get(values, 'data.relationships.premiums.data', []);
          if (premiumIds.length === 1) {
            dispatch(change('data.relationships', values.data.relationships));
            dispatch(change('included', values.included));
            dispatch(change('data.id', values.data.id));
            dispatch(change('data.attributes', values.data.attributes));
          }
        })
        .finally(() => {
          onSubmitSucceeded(true);
          onIsSaving(false);
          this.setState({
            isReadyForIssuing: true,
          });
          this.openSpecificTab(PAY_TAB);
        });
    }

    return Promise.resolve(
      onUpdateApplication(application, currentProduct, applicationId, null, mta, true),
    )
      .then((values) => {
        const premiumIds = get(values, 'data.relationships.premiums.data', []);
        if (premiumIds.length === 1) {
          dispatch(change('data.relationships', values.data.relationships));
          dispatch(change('included', values.included));
          dispatch(change('data.attributes', values.data.attributes));
          return true;
        }
        return false;
      })
      .finally(() => {
        onSubmitSucceeded(true);
        onIsSaving(false);
        this.setState({
          isReadyForIssuing: true,
        });
        this.openSpecificTab(PAY_TAB);
      });
  };

  handleSaveApplicationForPaymentTab = (application) => {
    const {
      dispatch,
      change,
      currentProduct,
      mta,
      onSaveApplication,
      onSubmitSucceeded,
      onIsSaving,
    } = this.props;
    return onSaveApplication(
      application,
      currentProduct,
      (values) => {
        const premiumIds = get(values, 'data.relationships.premiums.data', []);
        if (premiumIds.length === 1) {
          dispatch(change('data.relationships', values.data.relationships));
          dispatch(change('included', values.included));
          onSubmitSucceeded(true);
          onIsSaving(false);
          this.openSpecificTab(PAY_TAB);
        }
      },
      mta,
      true,
    );
  };

  checkSanctions = (application, schemeId) => {
    const { onCheckSanctions } = this.props;
    const adults = application?.data?.attributes?.metadata?.adults ?? [];
    const children = application?.data?.attributes?.metadata?.children ?? [];

    // Reset total sanctions count
    this.setState({
      totalSanctions: 0,
      sanctionCheckFailed: false,
    });
    const travellers = adults.concat(children);
    const address = application?.data?.attributes?.metadata?.adults?.[0]?.address;

    const toApi = getValuesForSanctions(travellers, address, schemeId);

    return Promise.resolve(onCheckSanctions(toApi))
      .then((response) => {
        const sanctionsChecked = response?.meta?.sanction ?? [];
        const { passed } = response.meta;
        const newAdults = adults.map((adult) => {
          const matchingSanction = sanctionsChecked.find(
            (sanction) => sanction.sanction_id === adult.sanction_id,
          );
          return {
            ...adult,
            sanction_result: matchingSanction.sanction,
            sanctions_check: matchingSanction.sanctions_check,
          };
        });
        const newChildren = children
          ? children.map((adult) => {
              const matchingSanction = sanctionsChecked.find(
                (sanction) => sanction.sanction_id === adult.sanction_id,
              );
              return {
                ...adult,
                sanction_result: matchingSanction.sanction,
                sanctions_check: matchingSanction.sanctions_check,
              };
            })
          : [];
        set(application, 'data.attributes.metadata.adults', newAdults);
        set(application, 'data.attributes.metadata.adults', newAdults);
        set(application, 'data.attributes.metadata.children', newChildren);
        set(application, 'data.attributes.metadata.sanctions_result', passed);
        set(
          application,
          'data.attributes.metadata.total_sanctions',
          sanctionsChecked?.length,
        );
        set(application, 'data.attributes.metadata.sanctions_check_complete', true);
        this.setState({
          totalSanctions: sanctionsChecked?.length,
          sanctionCheckFailed: !passed,
        });
        return {
          passed,
          application,
        };
      })
      .catch(() => {
        this.setState({
          totalSanctions: 0,
          sanctionCheckFailed: false,
        });
        return {
          passed: false,
          application,
        };
      });
  };

  // Invoked when clicked on 'Payment Tab'
  handlePaymentTab(application) {
    const { change, dispatch, mta, onSubmitSucceeded, onIsSaving } = this.props;

    onSubmitSucceeded(false);
    onIsSaving(true);
    if (mta) {
      set(
        application,
        'data.attributes.metadata.endorsements',
        get(application, 'data.attributes.metadata.storage.endorsements'),
      );
    }
    if (
      (isBroker() || isBrokerOrganisation()) &&
      application?.data?.attributes?.metadata?.adults?.[0]?.email
    ) {
      set(application, 'data.attributes.communications.email', true);
      set(application, 'data.attributes.metadata.send_email', true);
    }
    const applicationId = this.state.application?.data?.id;

    if (!mta || !!applicationId) {
      const schemes = application?.data?.relationships?.schemes;
      // Sanction check flag

      const selectedPremiums = getIncludedResource(
        application?.data,
        application?.included,
        'premiums',
      );
      const selectedScheme = selectedPremiums?.[0]?.scheme ?? schemes?.data?.[0];

      return Promise.resolve(this.checkSanctions(application, selectedScheme?.id)).then(
        (results) => {
          dispatch(change('data.attributes.metadata.sanctions_check_complete', true));
          return this.handleUpdateApplicationForPaymentTab(results.application);
        },
      );
    } else {
      return this.handleSaveApplicationForPaymentTab(application);
    }
  }

  handleSchemeTypeChange = () => {
    const { dispatch, change } = this.props;
    dispatch(change('data.relationships.schemes.data', []));
  };

  renderDefinitions = (name) => {
    const { currentProduct } = this.props;
    const definitionValue = get(
      currentProduct,
      `data.attributes.metadata.definitions.b2b.${name}`,
    );
    return <InfoButton content={definitionValue} />;
  };

  redirectToIssued = (policyId) => {
    const { onRedirectAfterSuccessfulCardPayment } = this.props;
    onRedirectAfterSuccessfulCardPayment(policyId);
  };

  render() {
    const {
      currentProduct,
      formValues,
      handleSubmit,
      product,
      resource,
      screening,
      mta,
      dispatch,
      change,
      error,
      submitFailed,
      brokerId,
      brokerType,
      isRenewal,
      isCalculating,
      isExpired,
      policyId,
      isMarketingEnabled,
      isInsuranceMarketingOptionsEnabled,
      isHomeInsuranceMarketingEnabled,
      isCarInsuranceMarketingEnabled,
    } = this.props;
    const {
      activeTab,
      isRecalculatingScore,
      isFlySure,
      ready,
      sanctionCheckFailed,
      isReadyForIssuing,
      isRescreenRequired,
    } = this.state;

    const declaration = get(
      currentProduct,
      'data.attributes.metadata.purchase_declaration',
      '',
    );
    // const formErrors = error && error instanceof Object ? flatten(error) : false;
    const classButton = (value) =>
      value === get(formValues, `${META}.traveller_group`) && 'buttonSelected';
    const isButtonSelected = get(formValues, META + '.traveller_group');
    const isGroupTypeError = get(error, 'attributes.metadata.traveller_group');
    const definitions = get(currentProduct, 'data.attributes.metadata.definitions', {});
    // Get the Premium selected to display in the SideBar
    const selectedSchemes = get(formValues, 'data.relationships.schemes.data', []);
    const selectedScheme =
      selectedSchemes && selectedSchemes.length === 1 ? selectedSchemes[0] : null; // 0 = no scheme selected
    const selection = selectedScheme ? get(product.quotes, selectedScheme.id) : {};
    const taxRate = selection ? get(selection, 'meta.rates.tax_rate', 0) : 0;

    // premiumIndication will be available once the singleCalculation is executed by a React Life Cycle
    const titleSection = (name, index, showCalc) => {
      return (
        <div className="header-title">
          {showCalc && product.isCalculating && (
            <div className="item-status">
              <span className="quote-title-top">Quotes</span>
              <Icon name="refresh" spin />
            </div>
          )}
          <div className="item-number">
            <span>{index}</span>
          </div>
          {name}
        </div>
      );
    };

    const availableQuotes = sortBy(product.quotes, 'meta.premium.gross');

    return (
      <div className={'leisure-travel-form'}>
        <Form horizontal>
          <div>
            <div className={'quotes-tabs' + (product.isSaving ? ' loading' : '')}>
              <div className="quote-tabs-content">
                <Tabs
                  unmountOnExit
                  id="leisure-travel"
                  onSelect={this.handleTab}
                  activeKey={this.state.activeTab}
                >
                  <Tab
                    eventKey={TRIP_DETAILS_TAB}
                    title={
                      <div className="number-tabs">
                        <span className={activeTab === TRIP_DETAILS_TAB ? 'red' : 'navy'}>
                          {' '}
                          1
                        </span>
                        Trip&#160;Details
                      </div>
                    }
                  >
                    {ready ? (
                      <div className="leisure-tab-content">
                        <TripDetailsTab01
                          isMta={mta}
                          change={change}
                          dispatch={dispatch}
                          unmountOnExit={false}
                          currentProduct={currentProduct}
                          openSpecificTab={this.openSpecificTab}
                          onSubmit={() => this.openSpecificTab(OPTIONS_TAB)}
                          definitions={get(
                            currentProduct,
                            'data.attributes.metadata.definitions.b2b',
                          )}
                          renderDefinitions={this.renderDefinitions}
                          onRegionDestinationChange={this.handleRegionDestinationChange}
                          isFlySure={isFlySure}
                          handleSchemeTypeChange={this.handleSchemeTypeChange}
                          isExpired={isExpired}
                        />

                        <div className="divider margin-bottom" />
                        <FormGroup>
                          <Col sm={4}>
                            <ControlLabel>
                              <span
                                style={
                                  isGroupTypeError && submitFailed
                                    ? { color: '#c22116' }
                                    : {}
                                }
                              >
                                Who is going? {this.renderDefinitions('group_type.b2b')}
                              </span>
                            </ControlLabel>
                          </Col>
                          <Col sm={6} className={'group-type-button-bar'}>
                            <FormGroup>
                              <Col sm={12}>
                                <ButtonBar>
                                  <Button
                                    individual
                                    handleClick={() => this.openTravellers('individual')}
                                    label={
                                      <span style={{ textTransform: 'none' }}>
                                        Individual(s)
                                      </span>
                                    }
                                    className={`btn-action-render ${classButton(
                                      'individual',
                                    )} ${isGroupTypeError &&
                                      submitFailed &&
                                      'buttonError'}`}
                                  />
                                  <Button
                                    couple
                                    label="Couple"
                                    handleClick={() => this.openTravellers('couple')}
                                    className={`btn-action-render ${classButton(
                                      'couple',
                                    )} ${isGroupTypeError &&
                                      submitFailed &&
                                      'buttonError'}`}
                                  />
                                  <Button
                                    family
                                    label="Family"
                                    handleClick={() => this.openTravellers('family')}
                                    className={`btn-action-render ${classButton(
                                      'family',
                                    )} ${isGroupTypeError &&
                                      submitFailed &&
                                      'buttonError'}`}
                                  />
                                  <Button
                                    family
                                    label="Group"
                                    handleClick={() => this.openTravellers('group')}
                                    className={`btn-action-render ${classButton(
                                      'group',
                                    )} ${isGroupTypeError &&
                                      submitFailed &&
                                      'buttonError'}`}
                                  />
                                </ButtonBar>
                              </Col>
                            </FormGroup>
                          </Col>
                        </FormGroup>
                        <div className="divider margin-bottom" />
                        {isButtonSelected && (
                          <div>
                            <TravellersDetailsTab01
                              currentProduct={currentProduct}
                              onSubmit={() => this.openSpecificTab(OPTIONS_TAB)}
                              openSpecificTab={this.openSpecificTab}
                              isRenewal={isRenewal}
                            />
                          </div>
                        )}
                      </div>
                    ) : (
                      <Loader />
                    )}
                  </Tab>
                  <Tab
                    eventKey={OPTIONS_TAB}
                    title={
                      <div className="number-tabs">
                        <span className={activeTab === OPTIONS_TAB ? 'red' : 'navy'}>
                          {' '}
                          2
                        </span>
                        Options
                      </div>
                    }
                  >
                    <div className="leisure-tab-content">
                      <TravellersOptionsTab02
                        formValues={formValues}
                        currentProduct={currentProduct}
                        renderDefinitions={this.renderDefinitions}
                      />
                      <div className="button-top-padding">
                        <ButtonBar includeDivider={true}>
                          <Button
                            label="Back"
                            id={'leisure-travel-option-btn-back'}
                            bsStyle="secondary"
                            disabled={screening.index !== 0}
                            className="pull-left btn-action-back"
                            handleClick={() => this.openSpecificTab(TRIP_DETAILS_TAB)}
                          />
                          <Button
                            label="Next"
                            bsStyle="primary"
                            id={'leisure-travel-option-btn-next'}
                            className="pull-right btn-action button-action-next"
                            disabled={screening.index !== 0}
                            handleClick={() => this.openSpecificTab(MEDICAL_TAB)}
                          />
                        </ButtonBar>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey={MEDICAL_TAB}
                    title={
                      <div className="number-tabs">
                        <span className={activeTab === MEDICAL_TAB ? 'red' : 'navy'}>
                          {' '}
                          3
                        </span>
                        Medical
                      </div>
                    }
                    // Don't render the component into the DOM until the active tab changes
                    // Requires unmountOnExit === false to medical screen react lifecycle be aware of props changes
                    // unmountOnExit={noMedical}
                  >
                    <div className="leisure-tab-content">
                      <MedicalDeclarationTab03
                        definitions={definitions}
                        productMedicalQuestions={
                          currentProduct.data.attributes.metadata
                            .medical_declaration_questions
                        }
                        //change={change}
                        //screening={screening}
                        //currentProduct={currentProduct}
                        // enableQuoteTab={this.enableQuoteTab}
                        // openSpecificTab={this.openSpecificTab}
                        isRescreenRequired={isRescreenRequired}
                        screeningIndex={screening.index}
                        onGoToPreviousPage={this.goToPreviousPage}
                        onGoToQuotes={this.goToQuotes}
                        onEnableQuoteTab={this.enableQuoteTab}
                        onClearError={this.clearScreeningError}
                        //calculateQuotes={this.calculateQuotes}
                        //renderDefinitions={this.renderDefinitions}

                        // updateTravellerScreening={this.updateTravellerScreening}
                      />
                    </div>
                  </Tab>
                  <Tab
                    eventKey={QUOTES_TAB}
                    disabled={isRecalculatingScore || isCalculating || isRescreenRequired}
                    title={
                      <div className="number-tabs">
                        <span className={activeTab === QUOTES_TAB ? 'red' : 'navy'}>
                          {' '}
                          4
                        </span>
                        {mta ? 'Calculate Adjustment' : 'Quotes'}
                      </div>
                    }
                  >
                    <div className="leisure-tab-content">
                      <Panel
                        eventKey={QUOTES_TAB}
                        className="panel-transparent"
                        header={titleSection(mta, isOwner(), true)}
                      >
                        <Field
                          definitions={definitions}
                          brokerId={brokerId}
                          productId={currentProduct?.data?.id}
                          brokerType={brokerType}
                          onToggleTest={this.handleToggleTest}
                          name="data.attributes.metadata.options"
                          // product={product}
                          //formValues={formValues}
                          component={CoverExclusions}
                          //calculateQuotes={this.calculateQuotes}
                        />
                        <AvailableQuotes
                          mta={mta}
                          change={change}
                          product={product}
                          dispatch={dispatch}
                          formValues={formValues}
                          handleSubmit={handleSubmit}
                          availableQuotes={availableQuotes}
                          handleSchemeSelect={this.handleSchemeSelect}
                          selectedSchemes={get(
                            formValues,
                            'data.relationships.schemes.data',
                            [],
                          )}
                          schemeType={get(
                            formValues,
                            'data.attributes.metadata.scheme_type',
                            'annual',
                          )}
                        />
                        <Signpost signpost={product.signpost} />
                        <PolicyUpgrades
                          hidden
                          mta={mta}
                          change={change}
                          product={product}
                          dispatch={dispatch}
                          formValues={formValues}
                          label={'Policy Upgrades'}
                          retrieveUpgrade={this.retrieveUpgrade}
                          updateBolton={this.props.updateBolton}
                          handleSchemeSelect={this.handleSchemeSelect}
                          selectedSchemes={get(
                            formValues,
                            'data.relationships.schemes.data',
                            [],
                          )}
                          onGoToReview={this.goToReview}
                        />
                        <PolicyOptionsMTA
                          change={change}
                          product={product}
                          dispatch={dispatch}
                          selectedSchemes={get(
                            formValues,
                            'data.relationships.schemes.data',
                            [],
                          )}
                          onGoToReview={this.goToReview}
                        />
                        <PolicyUpsell
                          hidden
                          change={change}
                          product={product}
                          dispatch={dispatch}
                          formValues={formValues}
                          currentProduct={currentProduct}
                          updateSelection={this.props.array}
                          confirmUpsell={this.confirmUpsell}
                          selectedSchemes={get(
                            formValues,
                            'data.relationships.schemes.data',
                            [],
                          )}
                        />
                      </Panel>
                      <div style={{ paddingTop: '20px' }}>
                        <ButtonBar includeDivider={true}>
                          <Button
                            label="Back"
                            bsStyle="secondary"
                            disabled={screening.index !== 0}
                            className="pull-left btn-action-back button-action-back"
                            handleClick={() => this.openSpecificTab(MEDICAL_TAB)}
                          />
                          <Button
                            label="Next"
                            bsStyle="primary"
                            className="pull-right btn-action button-action-next"
                            handleClick={() => this.openReviewTab(REVIEW_TAB)}
                          />
                        </ButtonBar>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey={REVIEW_TAB}
                    title={
                      <div className="number-tabs">
                        <span className={activeTab === REVIEW_TAB ? 'red' : 'navy'}>
                          {' '}
                          5
                        </span>
                        Review
                      </div>
                    }
                  >
                    <div className="leisure-tab-content">
                      <div>
                        <ReviewDetailsTab05
                          mta={mta}
                          change={change}
                          product={product}
                          dispatch={dispatch}
                          selection={selection}
                          goTab01={this.goTab01}
                          getPremium={selectedScheme}
                          formValues={formValues}
                          scrollToTop={scrollToTop}
                          currentProduct={currentProduct}
                          updateSelection={this.props.array}
                          singleCalculation={this.singleCalculation}
                          isMarketingEnabled={isMarketingEnabled}
                          isInsuranceMarketingOptionsEnabled={
                            isInsuranceMarketingOptionsEnabled
                          }
                          isHomeInsuranceMarketingEnabled={
                            isHomeInsuranceMarketingEnabled
                          }
                          isCarInsuranceMarketingEnabled={isCarInsuranceMarketingEnabled}
                          selectedSchemes={get(
                            formValues,
                            'data.relationships.schemes.data',
                            [],
                          )}
                        />
                      </div>
                      <div style={{ paddingTop: '20px' }}>
                        <ButtonBar includeDivider={true}>
                          <Button
                            label="Back"
                            bsStyle="secondary"
                            disabled={screening.index !== 0}
                            className="pull-left btn-action-back button-action-back"
                            handleClick={() => this.handleBackReviewTab()}
                          />
                          <Button
                            label="Next"
                            bsStyle="primary"
                            isLoading={product.isSaving}
                            disabled={screening.index !== 0}
                            handleClick={handleSubmit(this.handlePaymentTab)}
                            className={
                              product.isSaving ? 'pull-right button-action-next' : 'pull-right btn-action button-action-next'
                            }
                          />
                        </ButtonBar>
                      </div>
                    </div>
                  </Tab>
                  <Tab
                    eventKey={PAY_TAB}
                    title={
                      <div className="number-tabs">
                        <span className={activeTab === PAY_TAB ? 'red' : 'navy'}> 6</span>
                        Payment
                      </div>
                    }
                  >
                    <div className="leisure-tab-content">
                      {isReadyForIssuing && (
                        <>
                          {sanctionCheckFailed ? (
                            <FailedSanctions
                              adults={
                                formValues?.data?.attributes?.metadata?.adults ?? []
                              }
                              children={
                                formValues?.data?.attributes?.metadata?.children ?? []
                              }
                            />
                          ) : (
                            <PaymentTab06
                              isMta={mta}
                              productCode={product?.data?.attributes.product_code}
                              applicationFormValues={formValues}
                              declaration={declaration}
                              channelType={this.state.channelType}
                              redirectToIssued={this.redirectToIssued}
                              onUpdateTab={this.updateCurrentTab}
                            />
                          )}
                        </>
                      )}
                    </div>
                  </Tab>
                </Tabs>
              </div>
            </div>
          </div>
        </Form>
        {(get(formValues, 'data.relationships.source.data.id') || !isOwner || mta) && (
          <Sidebar
            mta={mta}
            taxRate={taxRate}
            resource={resource}
            formValues={formValues}
            policyId={policyId}
            getPremium={selectedScheme}
            currentProduct={currentProduct}
            revertUpsell={this.revertUpsell}
            goToNextPage={this.goToNextPage}
            application={formValues}
            calculateQuotes={this.calculateQuotes}
            isUpsellDirty={this.state.isUpsellDirty}
            singleCalculation={this.singleCalculation}
            isRescreenRequired={isRescreenRequired}
            isMultipleSchemeSelected={this.state.isMultipleSchemeSelected}
            isSignpostAcknowledged={
              get(formValues, 'data.attributes.metadata.signposted', false)
                ? get(formValues, 'data.attributes.metadata.signpost_acknowledged', false)
                : true
            }
            isRecalculatingScore={this.state.isRecalculatingScore}
            handleCommissionAdjustments={this.handleCommissionAdjustments}
          />
        )}
      </div>
    );
  }
}

const scrollToTop = () => {
  const scroll = animateScroll;
  scroll.scrollTo(1);
};

const form = reduxForm({ form: FORM_NAME, validate })(LeisureTravelForm);
const mapStateToProps = (state, props) => {
  return {
    formValues: getFormValues(FORM_NAME)(state),
    channel: state.channel,
    customer: state.customer,
    updateBolton: state.boltons,
    initialValues: props.resource,
    selectMenus: state.selectMenus,
    channels: state.channel.channels,
    isCalculating: state.product.isCalculating,
    upgradeModal: state.modal.modals.upgradeToGold,
    mtaUpgradeModal: state.modal.modals.policyOptionsMTA,
    upsellModal: state.modal.modals.PolicyUpsell,
  };
};

export default connect(
  mapStateToProps,
  {
    onGetChannel: channelActions.getChannel,
    channelActions: channelActions,
    onGetQuotes: productActions.getQuotes,
    onCalculateAdjustment: productActions.calculateAdjustment,
    onGetPremiumIndication: productActions.getPremiumIndication,
    onRedirectAfterSuccessfulCardPayment:
      productActions.redirectAfterSuccessfulCardPayment,
    onSubmitSucceeded: productActions.submitSucceeded,
    onIsSaving: productActions.isSaving,
    onSaveApplication: productActions.saveApplication,
    onUpdateApplication: productActions.updateApplication,
    onCheckSanctions: productActions.checkMultipleSanctions,
    onRecalculateScore: screenigActions.recalculateScore,
    onReduxChange: change,
  },
)(form);
